import axiosHandler from "./axiosHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getAllAppraisal = createAsyncThunk(
  "appraisal/getAllAppraisal",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(`/appraisal/getAllAppraisal`);
      return response?.data?.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const assignAppraisalTemplate = createAsyncThunk(
  "appraisal/assignTemplate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/assignTemplate`,
        data
      );
      if (response) {
        return response?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getUserAssignedAppraisalDetails = createAsyncThunk(
  "appraisal/getUserAssignedAppraisalDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/appraisal/getUserAssignedAppraisalDetails/` + id
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const deleteUserAssignedAppraisalById = createAsyncThunk(
  "appraisal/deleteUserAssignedAppraisalById",
  async ({ id, templateId }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.delete(
        `/appraisal/deleteUserAssignedAppraisalById/` + id + "/" + templateId
      );
      if (response) {
        return { ...response?.data, id };
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getAllUserAssignedAppraisal = createAsyncThunk(
  "appraisal/getAllUserAssignedAppraisal",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/appraisal/getAllUserAssignedAppraisal`
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getEmpAssignedAppraisal = createAsyncThunk(
  "appraisal/user/userid",
  async (data, { rejectWithValue }) => {
    try {
      const params = {};
      if (data?.selfOnly !== undefined) {
        params.selfOnly = data.selfOnly;
      }
      const response = await axiosHandler.get(
        `appraisal/user/` + data?.userId + "/" + (data?.status || "null"),
        { params }
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getManagerAssignedAppraisalById = createAsyncThunk(
  "appraisal/manager/userid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `appraisal/manager/` + data?.userId + "/" + data?.status
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getEmployeeAppraisalList = createAsyncThunk(
  "appraisal/getEmployeeAppraisalList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/getEmployeeAppraisalList`,
        data
      );
      if (response) {
        const data = response?.data?.data;
        return data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const createAppraisal = createAsyncThunk(
  "appraisal/create",
  async ({ editStatus, data }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(`/appraisal/create`, data);
      const responsedata = {
        editStatus: editStatus,
        data: response?.data?.data,
      };
      return responsedata;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const updateUserAdminAppraisal = createAsyncThunk(
  "appraisal/updateAppraisal",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/updateAppraisal/` + id,
        data
      );
      return response?.data?.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const submitFinalAppraisal = createAsyncThunk(
  "appraisal/reviewedFinalAppraisal",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/submitFinalAppraisal`,
        data
      );
      // const responsedata =
      return response?.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const deleteAppraisal = createAsyncThunk(
  "appraisal/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.delete(
        `/appraisal/deleteAppraisal/${id}`
      );
      if (response?.status === 200) {
        return id;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getStatusCountManagerAssignedAppraisal = createAsyncThunk(
  "appraisal/getStatusCountOfAppraisal",
  async ({ userId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/appraisal/getStatusCountOfAppraisal/${userId}`,
        {
          params: { startDate, endDate },
        }
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getAdminDashboardData = createAsyncThunk(
  "appraisal/getDataForAdminDashboard",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/appraisal/getDataForAdminDashboard`,
        {
          params: { startDate, endDate },
        }
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const updateUserAssignedAppraisal = createAsyncThunk(
  "appraisal/updateUserAssignedAppraisal",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/updateAssignedTemplate/${id}`,
        data
      );
      return response?.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getStatusCountUserAssignedAppraisal = createAsyncThunk(
  "appraisal/getStatusCountUserAssignedAppraisal",
  async ({ userId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/appraisal/getDataForUserDashboard/${userId}`,
        {
          params: { startDate, endDate },
        }
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const filterAppraisals = createAsyncThunk(
  "appraisal/filterAppraisals",
  async (filterData, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(
        `/appraisal/filterAppraisals`,
        filterData
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

const throwError = (error, rejectWithValue) => {
  return rejectWithValue(error?.response?.data || "An error occurred");
};
